import type { App } from 'vue'

import AppDialog from '@/components/common/AppDialog.vue'

export function installAppComponents(app: App): void {
  app.component('AppDialog', AppDialog)
}
